import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';
import { Override } from '../../../app-decorators';

@Injectable()
export class PermissionsPreconditionService extends BaseReportActionsHandler {
  @Override(BaseReportActionsHandler)
  public execute(): Promise<string | void> {
    if (this.isUserCompaniesMixed() && this.applyOnCurrentAction()) {
      return Promise.reject('Please select only users which belong to the same company');
    }

    return Promise.resolve();
  }

  // definitions to check if the precondition applies to the current action
  private applyOnCurrentAction(): boolean {
    const actionsToApply: string[] = [
      'ADD_WEBSHOP_CUSTOMER_PERMI',
      'REMOVE_WEBSHOP_CUSTOMER_PERMI',
      'ADD_COUNTRIES_CUSTOMER_PERMI',
      'REMOVE_COUNTRIES_CUSTOMER_PERMI',
      'ADD_REGIONS_CUSTOMER_PERMI',
      'REMOVE_REGIONS_CUSTOMER_PERMI',
      'ADD_SUBCOMPANY_CUSTOMER_PERMI',
      'REMOVE_SUBCOMPANY_CUSTOMER_PERMI'
    ];
    return _.contains(actionsToApply, this.action.code);
  }

  // return true in case that the selection contains a mix of users which belong to different companies
  private isUserCompaniesMixed(): boolean {
    const companies:number[] = [];
    _.each(this.rowSelection, (row: IObject) => {
      companies.push(row[ 'Decomnm' ] && row[ 'Decomnm' ].properties && row[ 'Decomnm' ].properties.companyId);
    });
    return _.uniq(companies).length > 1;
  }
}